var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCreditAccountsQuery, useProfileQuery } from 'syf-api';
import { useAllAccountSummaryQuery } from 'syf-api/allAccountSummary';
import { useMarketingPreferencesQuery } from '../pages/PreferenceCenter/services/marketingPrivacySettingsQuery';
import queryClient from '../const/queryClient';
import SyfStorage from './SyfStorage';
import { AccountIdType } from '../const/alertsConfig';
var getQueryOptions = function (enabled, queryOptions) {
    return __assign(__assign(__assign({}, queryClient.getQueryDefaults()), { enabled: enabled }), queryOptions);
};
var useCreditAccounts = function (config, queryOptions) {
    var enabled = Boolean(SyfStorage.getAccessToken());
    return useCreditAccountsQuery({
        keyProps: undefined,
        config: config,
        queryOptions: getQueryOptions(enabled, queryOptions)
    });
};
var useAllAccountSummary = function (config, accountSummaryKeys, queryOptions) {
    var keyProps = accountSummaryKeys;
    var enabled = Boolean(keyProps === null || keyProps === void 0 ? void 0 : keyProps.length);
    return useAllAccountSummaryQuery({
        keyProps: keyProps,
        config: config,
        queryOptions: getQueryOptions(enabled, queryOptions)
    });
};
var useProfileQueryData = function (config, accountId, queryOptions) {
    var keyProps = {
        accountId: accountId,
        accountIdType: AccountIdType.GUID
    };
    var enabled = Boolean(accountId);
    return useProfileQuery({
        keyProps: keyProps,
        config: config,
        queryOptions: getQueryOptions(enabled, queryOptions)
    });
};
var useMarketingPrivacyQueryData = function (config, accountId, queryOptions) {
    var keyProps = {
        accountId: accountId,
        accountIdType: AccountIdType.GUID
    };
    var enabled = Boolean(accountId);
    return useMarketingPreferencesQuery({
        keyProps: keyProps,
        config: config,
        queryOptions: getQueryOptions(enabled, queryOptions)
    });
};
export { useAllAccountSummary, useCreditAccounts, useProfileQueryData, useMarketingPrivacyQueryData };
